// extracted by mini-css-extract-plugin
module.exports = {"toastText":"index-toastText-2ljhw","toastTextHighlight":"index-toastTextHighlight-3qZfS","text":"index-text-1jIHT","highlight":"index-highlight-2Y0Eo"};